export function formatCNPJ(CNPJ: string) {
    let formattedCNPJ = CNPJ;

    formattedCNPJ = formattedCNPJ.substring(0, 2) + '.' +
    formattedCNPJ.substring(2, 5) + '.' +
    formattedCNPJ.substring(5, 8) + '/' +
    formattedCNPJ.substring(8, 12) + '-' +
    formattedCNPJ.substring(12, 14);

    return formattedCNPJ;
}

export function formatCPF(CPF: string) {
    let formattedCPF = CPF;

    formattedCPF = formattedCPF.substring(0, 3) + '.' +
    formattedCPF.substring(3, 6) + '.' +
    formattedCPF.substring(6, 9) + '-' +
    formattedCPF.substring(9, 11);

    return formattedCPF;
}

export function formatCEP(CEP: string) {
    let formattedCEP = CEP;

    formattedCEP = formattedCEP.substring(0, 5) + '-' +
    formattedCEP.substring(5, 8);
    
    return formattedCEP;
}